import Head from 'next/head';
import { useRouter } from 'next/router';
import { FunctionComponent } from 'react';

interface SEOProps {
  description?: string;
  title: string;
  siteTitle?: string;
  image?: string;
}

const SEO: FunctionComponent<SEOProps> = ({
  description = 'The simplest way to discover & enjoy Hindustani classical musicl',
  title,
  siteTitle = 'Ragya Web',
  image,
}) => {
  const router = useRouter();

  const fullTitle = `${title} | ${siteTitle}`;
  const imageUrl = image || 'https://ragya.com/logo.png'; // ✅ fallback logo
  const currentUrl = `https://ragya.com${router.asPath}`; // ✅ full canonical URL

  return (
    <Head>
      {/* Title and description */}
      <title>{fullTitle}</title>
      <meta name='description' content={description} />
      <link rel='canonical' href={currentUrl} />

      {/* Open Graph tags */}
      <meta property='og:type' content='website' />
      <meta property='og:title' content={fullTitle} />
      <meta property='og:description' content={description} />
      <meta property='og:site_name' content={siteTitle} />
      <meta property='og:image' content={imageUrl} />
      <meta property='og:url' content={currentUrl} />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='630' />
      <meta property='og:locale' content='en_IN' />

      {/* Twitter card tags */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={fullTitle} />
      <meta name='twitter:site' content='@ragyamusic' />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:image' content={imageUrl} />

      {/* For structed data */}
      <script
        type='application/ld+json'
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            url: currentUrl,
            name: fullTitle,
            description: description,
            image: imageUrl,
          }),
        }}
      />
    </Head>
  );
};

export default SEO;
